module.exports = __webpack_public_path__ + "static/media/q.245cbad1.svg";